import service from "./index";
import cookie from "react-cookies";
import { SingleItem } from "../pages/localChanges/wizard/LinkRecordsFilter";
import { RIMS_COOKIE_CONSTANTS } from "../constants";

const prefix = "/lcm";

const appendLcmVersionParams = (
  baseUrl: string,
  lcmMajorVersion?: string | number,
  lcmMinorVersion?: string | number,
) => {
  let url = baseUrl;
  if (lcmMajorVersion != null && lcmMajorVersion !== "") {
    url += `${url.includes("?") ? "&" : "?"}lcmMajorVersion=${lcmMajorVersion}`;
  }
  if (lcmMinorVersion != null && lcmMinorVersion !== "") {
    url += `${url.includes("?") ? "&" : "?"}lcmMinorVersion=${lcmMinorVersion}`;
  }
  return url;
};

export const apiGetLCMFormData = (
  id: string
): Promise<API.DataResponse<API.LCM>> =>
  service.services.get(`${prefix}/registrations/${id}`);

export const apiGetLCMSideMenu = (
  lcmId: string,
  lcmMajorVersion?: string | number,
  lcmMinorVersion?: string | number,
): Promise<API.DataResponse<API.MenuManagerMenuItem[]>> => {
  const baseUrl = `${prefix}/lcms/side-menu?lcmId=${lcmId}`;
  return service.service.get(
    appendLcmVersionParams(baseUrl, lcmMajorVersion, lcmMinorVersion),
  );
};

export const getRelatedMenuResourceList = (
  body: any
): Promise<API.DataResponse<any>> =>
  service.service.post("common-uam/resources/menu/related-resource", body);

export const apiDeleteLCMRelated = (
  id: string
): Promise<API.DataResponse<boolean>> =>
  service.services.delete(`${prefix}/registrations/related/${id}`);

export const apiAddLcm = (
  data: API.LCMVo
): Promise<API.DataResponse<Record<string, any>[]>> =>
  service.service.post(`${prefix}/lcms`, data);

export const checkLcmAutoLaunchProcess = (
  id: string | number
): Promise<API.DataResponse<unknown>> =>
  service.service.get(`${prefix}/process/check-auto-launch/${id}`);

export type RecurrenceObligationResultItem = {
  id: string;
  /** Reserved for future use. */
  associatedRecordIds: string[];
};

/** Create obligations with recurrence (async task). */
export const apiAddLcmWithRecurrence = (
  data: API.LCMVo & { recurrence?: string },
): Promise<
  API.DataResponse<{ jobId: string; totalCount: number }>
> => service.service.post(`${prefix}/lcms/obligations`, data);

/** Poll obligation creation task. */
export const apiGetRecurrenceTaskStatus = (
  jobId: string,
): Promise<
  API.DataResponse<{
    jobId: string;
    status: string;
    createdCount: number;
    totalCount: number;
    result?: RecurrenceObligationResultItem[];
    message?: string;
  }>
> => service.service.get(`${prefix}/lcms/obligations/jobs/${jobId}`);

/** Poll generic async task (e.g. lifecycle clone). */
export const apiGetAsyncTaskStatus = (
  taskId: string,
): Promise<
  API.DataResponse<{
    status: string;
    message?: string;
    /** Reserved */
    task?: unknown;
    /** Reserved */
    result?: unknown;
  }>
> =>
  service.service.get(
    `${prefix}/lcms/async/tasks/${encodeURIComponent(taskId)}`,
  );

export const apiAddLocalChange = (
  data: API.LCMVo
): Promise<API.DataResponse<Record<string, any>[]>> =>
  service.service.post(`${prefix}/lcms/local-changes`, data);

export const apiGetlcmPage = (
  data: API.LCMPageParams
): Promise<API.DataResponse<API.PageResult<API.LCM[]>>> =>
  service.service.post(`${prefix}/lcms/page`, data);

export const apiDeleteLCM = (
  // id: string,
  params: API.DisableContent
): Promise<API.DataResponse<boolean>> =>
  service.service.delete(`${prefix}/lcms/${params.id}`, {
    data: { reason: params.reason, comment: params.comment },
  });

/** Logical delete with reason (mirrors registration `deleteRegistrationLogically` under `/lcm/lcms`). */
export const apiDeleteLcmLogically = (
  id: string,
  reason: string,
): Promise<API.DataResponse<boolean>> =>
  service.service.delete(`${prefix}/lcms`, {
    data: {
      id,
      reason,
    }
  });

export const createDocument = (params: {}) =>
  service.service.post(`${prefix}/document`, params);

export const updateDocument = (params: {}) =>
  service.service.put(`${prefix}/document`, params);

export const deleteDocument = (params: {}) =>
  service.service.delete(`${prefix}/document/product/delete`, { data: params });

export const getDocumentById = (queryId: string) =>
  service.service.get(`${prefix}/document/product/${queryId}`);

export const UPLOAD_DOCUMENT = `${prefix}/document/upload`;

export const downLoadDocument = (queryId: string) =>
  service.service.get(
    `${prefix}/document/generate-preSignedUrl?documentId=${queryId}`
  );

export const relatedImpactAsessment = (params: {}) =>
  service.service.post(`${prefix}/related/impact-asessment`, params);

export const getImpactAssementList = () =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
    )}&module=lcm&label=LCMImpactAssessment`
  );

export const getLCMList = (params = { pageNum: 1, pageSize: 1000000 }) =>
  service.service.post(`${prefix}/lcms/page`, params);

export const createLCM = (productInfo: {}) =>
  service.service.post(`${prefix}/lcms`, productInfo);

export const updateLCM = (productInfo: {}) =>
  service.service.put(`${prefix}/lcms`, productInfo);

export const getLCMDetail = (
  id: string | number,
  lcmMajorVersion?: string,
  lcmMinorVersion?: string,
) =>
  service.service.get(
    appendLcmVersionParams(`${prefix}/lcms/${id}`, lcmMajorVersion, lcmMinorVersion),
  );

export const apiGetLCMLinkRecordPage = (params: {
  lcmId: string;
  menu: string | number;
  section: string;
  // }): Promise<API.DataResponse<API.LCMMenuItem[]>> =>
}): Promise<
  API.DataResponse<API.GridData<{ id: string;[key: string]: string }[]>>
> =>
  service.service.get(`${prefix}/related/page`, {
    params,
  });

export const apiGetRegistrationUpdatePage = (params: {
  lcmId: string;
  menuOrder: string | number;
}): Promise<API.DataResponse<API.PageResult<API.LCMMenuItem[]>>> =>
  service.service.get(`lcm/related/page`, {
    params,
  });

export const apiGetLocalChangesLinkRecordPage = (
  params: API.RegistrationsPageParams
): Promise<API.DataResponse<API.PageResult<API.Registrations[]>>> =>
  service.service.get(`${prefix}/related/local-changes/linked-records`, {
    params,
  });

export const apiAddLcmLinkModule = (params: {
  lcmId: string;
  menuName: string | number;
  dynamicFieldJson: string;
  section: string;
}): Promise<API.DataResponse<API.LCMMenuItem[]>> =>
  service.service.post(`${prefix}/related`, params);

export const apiUpdateLcmLinkModule = (params: {
  lcmId: string;
  menuName: string | number;
  dynamicFieldJson: string;
  section: string;
}): Promise<API.DataResponse<API.LCMMenuItem[]>> =>
  service.service.put(`${prefix}/related`, params);

export const apiGetLcmLinkModuleDetail = (
  id: string,
  lcmId?: string,
  lcmMajorVersion?: string | number,
  lcmMinorVersion?: string | number,
): Promise<API.DataResponse<API.LCMMenuItem[]>> => {
  const hasVersion =
    (lcmMajorVersion != null && lcmMajorVersion !== "") ||
    (lcmMinorVersion != null && lcmMinorVersion !== "");
  let baseUrl = `${prefix}/related/${id}`;
  if (hasVersion && lcmId) {
    baseUrl += `?lcmId=${lcmId}`;
  }
  return service.service.get(
    hasVersion
      ? appendLcmVersionParams(baseUrl, lcmMajorVersion, lcmMinorVersion)
      : baseUrl,
  );
};

export const apiDeleteLCMRelatedModule = (
  id: string
): Promise<API.DataResponse<boolean>> =>
  service.service.delete(`${prefix}/related/${id}`);

export const checkLcmDependencies = (params: Object) =>
  service.service.get(`${prefix}/related/dependencies`, { params });

export const apiGetApplicationsPage = (): Promise<
  API.DataResponse<any>
> =>
  service.service.post(`${prefix}/proxy`, {
    module: "application",
    type: "post",
    path: "/v2/display-all/refresh-products",
    header: {
      "X-tenantId": cookie.load(RIMS_COOKIE_CONSTANTS.USER_TENANT_ID),
    },
    data: "{\"approved\":true,\"draft\":true,\"inProgress\":true,\"onHold\":true,\"page\":0,\"rejected\":true,\"size\":999999,\"submitted\":true,\"withdrawn\":true}"
  });

export const apiGetFilterApplicationsPage = (params: {
  [key: string]: SingleItem | number | undefined;
}): Promise<
  API.DataResponse<{
    pageNum: number;
    pageSize: number;
    total: number;
    content: API.Applications[];
    data: API.Applications[];
  }>
> => service.service.post(`${prefix}/lcms/filter-application`, params);

export const apiGetFilterRegistrationPage = (
  // params: { [key: string]: SingleItem | number | undefined }
  params: any
): Promise<
  API.DataResponse<{
    pageNum: number;
    pageSize: number;
    total: number;
    data: API.Registrations[];
  }>
> => service.service.post(`${prefix}/lcms/filter-registration`, params);

export const apiGetRegistrationsPage = (params: any) => service.service.post(`registration/registrations/global/filter`, params);

export const apiGetCommitmentsPage = (params: any) => service.service.post(`${prefix}/lcms/page`, params);

export const apiBasicInfoCategoryOptions = (
  field: string
): Promise<API.DataResponse<API.DropdownItem[]>> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
    )}&module=lcm&label=${field}Category`
  );

export const apiBasicTypeOptions = (
  field: string
): Promise<API.DataResponse<API.DropdownItem[]>> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
    )}&module=lcm&label=${field}Type`
  );

export const apiBasicInfoSubTypeOptions = (
  field: string
): Promise<API.DataResponse<API.DropdownItem[]>> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
    )}&module=lcm&label=${field}Subtype`
  );

export const apiGetProductFamilyList = (): Promise<
  API.DataResponse<{ id: string; name: string }[]>
> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
    )}&module=product&label=ProductFamily`
  );
export const apiGetProductPhaseList = (): Promise<
  API.DataResponse<{ id: string; name: string; code: string }[]>
> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
    )}&module=product&label=ProductPhase`
  );

export const apiGetLCMRegionList = (): Promise<
  API.DataResponse<{ id: string; name: string }[]>
> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
      // )}&module=registrations&label=CountryGroup`
    )}&module=lcm&label=CountryGroup`
  );

export const apiGetProcedureTypeOptions = (
  countryGroup: string
): Promise<API.DataResponse<{ id: string; name: string }[]>> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
      // )}&module=registrations&label=ProcedureType&groupLabel=CountryGroup&filter=${countryGroup}`
    )}&module=lcm&label=ProcedureType&groupLabel=CountryGroup&filter=${countryGroup}`
  );

export const apiLcmGetCountryList = (
  countryGroup: string
): Promise<API.DataResponse<{ id: string; name: string }[]>> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
      // )}&module=registrations&label=Country&groupLabel=CountryGroup&filter=${countryGroup}`
    )}&module=lcm&label=Country&groupLabel=CountryGroup&filter=${countryGroup}`
  );
export const apiFetchReasonOptions = (): Promise<
  API.DataResponse<API.DropdownItem[]>
> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
    )}&module=lcm&label=ReasonForDisable`
  );

export const apiGetRecordMetaData = (params: {
  lcmId: string;
  section: string;
  lcmMajorVersion?: string | number;
  lcmMinorVersion?: string | number;
}): Promise<API.DataResponse<API.DocsMetaData>> => {
  const baseUrl = `${prefix}/related/recordMetaDataList?lcmId=${params.lcmId}&section=${params.section}`;
  return service.service({
    type: "get",
    url: appendLcmVersionParams(
      baseUrl,
      params.lcmMajorVersion,
      params.lcmMinorVersion,
    ),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}
// service.serviceRegistrations({
//     {
//   type: "get",
//   url: `${prefix}/lcms/related/recordMetaDataList?lcmId=${params.lcmId}`,
//   headers: {
//     "Content-Type": "application/json;charset=UTF-8",
//   },
// }

// export const apiAddMetaData = (data: any): Promise<API.DataResponse<boolean>> =>
//   service.serviceRegistrations.post(`${prefix}/registrations`, data);

// export const apiUpdateMetaData = (
//   data: any
// ): Promise<API.DataResponse<boolean>> =>
//   service.serviceRegistrations.put(`${prefix}/registrations`, data);

export const apiGetLCMFormSetting = (data: {
  module: string;
  formName: string;
  lcmId?: string;
  section?: string;
  businessRule?: Record<string, unknown>;
  lcmMajorVersion?: string;
  lcmMinorVersion?: string;
}): Promise<API.DataResponse<API.FormSettings>> =>
  service.service.post(`${prefix}/cm/forms/settings`, data);

export const fetchProductTree = (
  relatedId: string,
  params?: {
    lcmMajorVersion?: string | number;
    lcmMinorVersion?: string | number;
  },
): Promise<API.DataResponse<API.SearchableTreeGroupItem<API.TreeMenuItem>[]>> =>
  service.service.get(`${prefix}/related/relatedProductsTree/${relatedId}`, { params });

export const fetchProductDraft = (data: {
  scope: string;
  section: string;
  relatedId: string;
  lcmMajorVersion?: string | number;
  lcmMinorVersion?: string | number;
}): Promise<API.DataResponse<API.ProductDraftData>> =>
  service.service.get(
    `${prefix}/related/regUpdate/draft`, { params: data }
  );

export const fetchRegistrationTree = (data: {
  registrationId: string;
}): Promise<
  API.DataResponse<API.SearchableTreeGroupItem<API.TreeMenuItem>[]>
> =>
  service.service.get(`${prefix}/cm/registration/side-menu`, {
    params: data,
  });

export const getRegistrationFormSetting = (data: {
  domain: string;
  formName: string;
  section: string;
  registrationId: string;
  module: string;
}): Promise<API.DataResponse<API.FormSettings>> =>
  service.service.post(`${prefix}/cm/registration/forms/settings`, data);

export const checkConflict = (
  data: API.FetchDraftParams
): Promise<API.DataResponse<boolean>> =>
  service.service.put(`${prefix}/related/checkcheck/draft`, data);

export const saveDraftDataForm = (
  data: API.FetchDraftParams & { forceUpdate: boolean }
): Promise<API.DataResponse<any>> =>
  service.service.put(`${prefix}/related/regUpdate/draft/form`, data);

export const saveDraftDataGrid = (
  data: API.FetchDraftParams
): Promise<API.DataResponse<any>> =>
  service.service.put(`${prefix}/related/regUpdate/draft/grid`, data);

export const batchUpdateRegistrations = (
  data: API.UpdateViaLcmReqVO
): Promise<API.DataResponse<any>> =>
  service.service.post(`${prefix}/related/regUpdate/updateViaLcm`, data);

export const getRegistrationList = (): Promise<API.DataResponse<any>> =>
  service.service.get(`${prefix}/registration/section-tree`);

export const getRegSubMenuTableData = (data: {
  relatedId: string;
  section: string;
  menu: string;
  lcmMajorVersion?: string | number;
  lcmMinorVersion?: string | number;
}): Promise<API.DataResponse<any>> =>
  service.service.get(
    `${prefix}/related/regUpdate/draft/list`, { params: data }
  );

export const getRegSubMenuTableDataDetail = (data: {
  relatedId: string;
  section: string;
  menu: string;
  scope: string;
  id?: string | null;
  lcmMajorVersion?: string | number;
  lcmMinorVersion?: string | number;
}): Promise<API.DataResponse<any>> => {
  return service.service.get(`${prefix}/related/regUpdate/draft`, {
    params: data,
  });
};

export const getProductFormSetting = (data: {
  module: string;
  formName: string;
  productId: string;
  section: string;
}): Promise<API.DataResponse<any>> => {
  return service.service.post(`${prefix}/cm/product/forms/settings`, data);
};

export const refreshSnapshotRecrod = (data: any): Promise<API.DataResponse<any>> => service.service.post(`${prefix}/related/regUpdate/refresh`, data);

export const updateRecordStatus = (params: {
  lcmId: string,
  lifecycleComment: string,
  lifecycleStages: string,
  menuName?: string
}): Promise<
  API.DataResponse<Record<string, unknown> & { asyncKey?: string }>
> => service.service.put(`${prefix}/lcms/lifecycles`, params)

export const apiGetCurrentRegulatoryStatus = (
  lcmId: string,
): Promise<API.DataResponse<API.RegulatoryStatusCurrent>> =>
  service.service.get(`${prefix}/regulatory/status/current`, {
    params: { lcmId },
  });

export const apiUpdateRegulatoryStatus = (
  params: API.RegulatoryStatusUpdateParams,
): Promise<API.DataResponse<unknown>> =>
  service.service.put(`${prefix}/regulatory/status/update`, params);

export const apiGetRegulatoryStatusHistory = (
  lcmId: string,
): Promise<API.DataResponse<API.RegulatoryStatusHistoryItem[]>> =>
  service.service.get(`${prefix}/regulatory/status/list-all`, {
    params: { lcmId },
  });

/** RecordStatus KM dropdown for regulatory status badge. */
export const apiFetchRecordStatusDropdown = (): Promise<
  API.DataResponse<API.DropdownItem[]>
> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN,
    )}&module=lcm&label=RecordStatus`,
  );

export const apiFetchLifeCycleOptions = (label: string): Promise<
  API.DataResponse<API.DropdownItem[]>
> =>
  service.service.get(
    `${prefix}/km/dropdown-list?domain=${cookie.load(
      RIMS_COOKIE_CONSTANTS.DOMAIN
    )}&module=lcm&label=${label}`
  );

export const batchBindIdentifier = (body: API.LcmBatchBindIdentifierBody) => service.service.post(`${prefix}/identifiers/batch-binding`, body);

export const batchRemoveIdentifier = (body: API.BatchRemoveIdentifierBody) => service.service.delete(`${prefix}/identifiers/batch-binding`, { data: body });

export const bindIdentifiers = (body: API.BindIdentifiersBody) => service.service.post(`${prefix}/identifiers/binding`, body);

export const updateBindIdentifiers = (body: API.BindIdentifiersBody) => service.service.put(`${prefix}/identifiers/binding`, body);

export const queryIdentifier = (body: API.QueryIdentifierBody) => service.service.post(`${prefix}/identifiers/query`, body);

export const apiCmValidCheck = (type: 'save' | 'delete' | 'update', body: {}) => service.service.post(`${prefix}/related/cm/valid-check/${type}`, body);

export const apiLcmValidCheck = (body: {}) => service.service.post(`${prefix}/lcms/cm/valid-check`, body);
export const getLifeCycleRelations = (params: any) => service.service.post(`${prefix}/km/relation-name`, params);

export const getLifeCycleConcept = (params: any) => service.service.post(`${prefix}/km/concept-relation`, params);

export const fetchLcmDataVersion = (
  lcmId: string,
  params?: {
    lcmMajorVersion?: string | number;
    lcmMinorVersion?: string | number;
  },
) =>
  service.service.get(
    appendLcmVersionParams(
      `${prefix}/lcms/version/${lcmId}`,
      params?.lcmMajorVersion,
      params?.lcmMinorVersion,
    ),
  );
// Impact Record
export const getLinkRecordData = (queryResponseId: string) => service.service.get(`${prefix}/linked-record/list/${queryResponseId}`);

export const getImpactedRecordData = (
  queryResponseId: string,
  lcmMajorVersion?: string | number,
  lcmMinorVersion?: string | number,
) => {
  const baseUrl = `${prefix}/impacted-record/list/${queryResponseId}`;
  const hasVersion =
    (lcmMajorVersion != null && lcmMajorVersion !== "") ||
    (lcmMinorVersion != null && lcmMinorVersion !== "");
  return service.service.get(
    hasVersion
      ? appendLcmVersionParams(baseUrl, lcmMajorVersion, lcmMinorVersion)
      : baseUrl,
  );
};

export const createImpactedRecord = (params: {}) => service.service.post(`${prefix}/impacted-record/save`, params);

export const deleteImpactRecord = (impactedRecordId: string) => service.service.delete(`${prefix}/impacted-record/${impactedRecordId}`);

export const getObligationImpactMenuList = () => service.service.get(`${prefix}/category/rtq-categories?concept=LCMCategory`);

export const getCommitmentImpactMenuList = () => service.service.get(`${prefix}/category/rtq-categories?concept=LCMCategory`);

export const getLocalChangeImpactMenuList = () => service.service.get(`${prefix}/category/rtq-categories?concept=LCMCategory`);

export const getListKMData = (category: string) => service.service.get(`${prefix}/category/km/nodes?concept=${category}`);

/** KM nodes by concept (Impact Record Product Family and LCM link pickers). */
export const getKmNodesByConcept = (concept: string) =>
  service.service.get(`${prefix}/km/nodes?concept=${encodeURIComponent(concept)}`);

export const getSubmissionGridSetting = () => service.service.get(`${prefix}/category/submission/settings`);

export const getApplicationData = () => service.service.post(`${prefix}/lcms/filter-application`, {});

export const getSubmissionsData = () => service.service.get(`${prefix}/category/submission/page`);

export const getLCMData = (data: any) => service.service.post(`${prefix}/lcms/page`, data);

export const fetchQueryList = (params: {}) => service.service.post(`${prefix}/query-response/global/filter`, params);

/** RTQ list for LCM impacted records (BE dynamic page; no lifecycle). */
export const fetchRtqDynamicPage = (params: Record<string, unknown>) =>
  service.service.post("/hai/query-response/dynamic/page", params);

export const fetchCatogeryList = (params: any) => service.service.get(`${prefix}/category/lcm-categories`, { params });

export const getLcmFullCategoryList = (params: { concept: string }) =>
  service.service.get(`${prefix}/category/lcm-full-categories`, { params });

export const queryDefaultIdentifier = (body: any): Promise<API.DataResponse<any>> => service.service.post(`${prefix}/identifiers/query-autoTag`, body);

export const queryAllIdentifiers = (): Promise<API.DataResponse<any>> => service.service.get(`common-uam/identifiers/getOnboardedIdentifiers`);

export const getAuditInfoById = (id: string): Promise<API.DataResponse<API.AuditInfo>> => service.service.get(`${prefix}/lcms/audit-info/${id}`);
export const createLcmExportTask = (
  data: API.LcmExportTaskParams
): Promise<API.DataResponse<string>> =>
  service.service.post(`${prefix}/lcms/export/task`, data);

export const getLcmExportTaskStatus = (
  taskId: string
): Promise<API.DataResponse<API.LcmExportTaskStatus>> =>
  service.service.get(`${prefix}/lcms/export/task/${taskId}`);

export const createLcmCloneTask = (
  lcmId: string | number,
): Promise<API.DataResponse<string>> =>
  service.service.post(`${prefix}/lcms/${lcmId}/clone`, {});

export const getLcmCloneTaskStatus = (
  lcmId: string | number,
  taskId: string,
): Promise<API.DataResponse<API.LcmCloneTaskStatus>> =>
  service.service.get(`${prefix}/lcms/${lcmId}/clone/task/${taskId}`);

export const checkLcmAccess = (lcmId: string): Promise<API.DataResponse<any>> =>
  service.service.get(`${prefix}/lcms/access-check/${lcmId}`);

export const deleteChildRecordValidCheck = (id: string): Promise<API.DataResponse<{
  menu: string,
  section: string,
  recordId: string,
}[]>> => service.service.get(`${prefix}/related/deleteCheckRelatedRecord?id=${id}`);

export const deleteImpactedRecordValidCheck = (id: string): Promise<API.DataResponse<{
  menu: string,
  section: string,
  recordId: string,
}[]>> => service.service.get(`${prefix}/impacted-record/deleteCheckImpactedRecord?id=${id}`);

export const createRegExportTask = (params: API.ExportTaskParams) =>
  service.service.post(`/registration/registrations/export/task`, params);
export const createExportTask = (params: API.ExportTaskParams, url: string) =>
  service.service.post(url, params);
export const getRegExportTaskStatus = (taskId: string) =>
  service.service.get(`/registration/registrations/export/task/${taskId}`);
export const getExportTaskStatus = (url: string) =>
  service.service.get(url);
export const getHistoryVersions = (
  id: string,
): Promise<API.DataResponse<any>> =>
  service.service.get(`${prefix}/lcms/backup-version/list?lcmId=${id}`);

export const getLcmTags = (params: {
  lcmId: string;
  lcmMajorVersion?: string | number;
  lcmMinorVersion?: string | number;
}): Promise<API.DataResponse<API.LcmTagItem[]>> =>
  service.service.get(`${prefix}/lcms/tags`, { params });

export const createRcsRegistrationExportTask = (body: {
  module: string;
  fileType: number;
  id: string;
  recordId?: string;
}): Promise<API.DataResponse<{ taskId: string }>> =>
  service.service.post(`/rcs/export/task`, body);

export const getRcsExportTaskStatus = (
  taskId: string,
): Promise<
  API.DataResponse<{
    taskId: string;
    status: string;
    downloadUrl?: string;
    fileName?: string;
  }>
> => service.service.get(`/rcs/export/task/${taskId}`);

export const getGroupMenus = (params: any) =>
  service.service.get(`${prefix}/common-cm/group/menus`, { params });

export const getWizardFormByMenuName = (params: any) =>
  service.service.get(`${prefix}/common-cm/steps/fields`, { params });

export const getKmByCode = (params: any) =>
  service.service.post(`${prefix}/km/nodeNames`, params);

export const getFeatureFlag = (params: any) =>
  service.service.get(`${prefix}/tm/feature-flags`, { params });

export const getLcmHistoryVersions = (
  data: {
    lcmId: string;
    majorVersion?: string | number;
    minorVersion?: string | number;
  },
): Promise<any> =>
  service.service.get(`/lcm/docs/version-record-ids`, { params: data });